/* src/components/library-item-filters-options/library-item-filters-options.component.scss */
app-library-item-filters-option {
  display: block;
}
/*# sourceMappingURL=library-item-filters-options.component-AH3USSPV.css.map */
